import { ReactElement } from 'react';

import {
  Box,
  BoxProps,
  CircularProgress,
  CircularProgressProps,
} from '@mui/material';

type SignupStepLoadingProps = {
  BoxProps?: Omit<BoxProps, 'children'>;
  CircularProgressProps?: CircularProgressProps;
};

export const SignupStepLoading = (
  props: SignupStepLoadingProps,
): ReactElement => {
  return (
    <Box
      {...props.BoxProps}
      sx={{
        height: 'calc(100vh - 230px)',
        display: 'grid',
        placeItems: 'center',
        ...props.BoxProps?.sx,
      }}
    >
      <CircularProgress {...props.CircularProgressProps} />
    </Box>
  );
};
